module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2f"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/fm03"
    }
  }, [_c('em', [_vm._v("Sleeve Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part01"
    }
  }, [_vm._v("SIDE ONE: Play It Loud")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("1.")]), _vm._v(" Mr Stenhouse, Philip Larkin, Going to Hell")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter02"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("2.")]), _vm._v(" The Happy Smile Club")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter03"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("3.")]), _vm._v(" Primary School: First Thoughts, as They Occur, as If to a Therapist")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter04"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("4.")]), _vm._v(" Brigitte Bardot Came to North Berwick and Nobody Noticed")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter05"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("5.")]), _vm._v(" Calum Kennedy: Kilty by Suspicion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("6.")]), _vm._v(" A Poem")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("7.")]), _vm._v(" The Music Period: ‘Sing soft, man, y’know I mean like wow.’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("8.")]), _vm._v(" The Marconiphone E1")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("9.")]), _vm._v(" The Man Who Put the Bang in Gang")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("10.")]), _vm._v(" What Fruit Grows on Telegraph Poles?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("11.")]), _vm._v(" An Engineer Answers the Telephone")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("12.")]), _vm._v(" The Princess and the Tree")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("13.")]), _vm._v(" Yeti-Hunting at the Harbour Pavilion (Part One)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("14.")]), _vm._v(" Career Opportunities Never Knock")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("15.")]), _vm._v(" Sunglasses After Dark in a 1970s Weirdo Apocalypse (Yeti-Hunting Part Two)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("16.")]), _vm._v(" Rod Stewart Came to North Berwick and Nobody Noticed")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("17.")]), _vm._v(" Dave Hill Is Five Foot Three")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("18.")]), _vm._v(" (Never Listen to) Electric Guitar")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("19.")]), _vm._v(" Oral History: An Ultra-Year-Zero Moment")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("20.")]), _vm._v(" Readmore Books")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("21.")]), _vm._v(" Sex Pistols: ‘Who’s Oor Wullie?’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("22.")]), _vm._v(" Salad Days")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("23.")]), _vm._v(" The Body in the Boot")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("24.")]), _vm._v(" Alone Here in My Half-Empty Bed")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("25.")]), _vm._v(" Who Are the Poofs?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("26.")]), _vm._v(" Gary Don’t Need His Eyes to See")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("27.")]), _vm._v(" A Different Kind of Tension")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("28.")]), _vm._v(" A Non-Sexist Night Out")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("29.")]), _vm._v(" A Horrible, Truculent Youth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("30.")]), _vm._v(" Dead Letter Office: ‘I thought you were Aztec Camera for a while.’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("31.")]), _vm._v(" The Square Window")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("32.")]), _vm._v(" Are We Not, Or Are We Not Going to North Berwick Now?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter33",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("33.")]), _vm._v(" The Quarterdeck")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SIDE TWO: Listen with Prejudice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter34",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("34.")]), _vm._v(" My Life as a Fanzine")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter35",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("35.")]), _vm._v(" Fish Pie Talks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter36",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("36.")]), _vm._v(" Edward Heath")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter37",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("37.")]), _vm._v(" Black")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter38",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("38.")]), _vm._v(" The Fall")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter39",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("39.")]), _vm._v(" Robert Smith")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter40",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("40.")]), _vm._v(" Billy MacKenzie")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter41",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("41.")]), _vm._v(" Red Wedge")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter42",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("42.")]), _vm._v(" Shane MacGowan")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter43",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("43.")]), _vm._v(" Paul McCartney")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter44",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("44.")]), _vm._v(" Tony Wilson")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter45",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("45.")]), _vm._v(" A Cup of Tea with Mr Cutler")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter46",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("46.")]), _vm._v(" Nirvana")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter47",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("47.")]), _vm._v(" Kate Moss")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter48",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("48.")]), _vm._v(" Juergen Teller")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter49",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("49.")]), _vm._v(" The Many Moods of Iggy Pop")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter50",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("50.")]), _vm._v(" Tilda Swinton")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter51",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("51.")]), _vm._v(" Mo Mowlam: Diplomacy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter52",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("52.")]), _vm._v(" Rod Stewart")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter53",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("53.")]), _vm._v(" Dolly Parton")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter54",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("54.")]), _vm._v(" Willie Nelson")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter55",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("55.")]), _vm._v(" Shirley Manson")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter56",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_vm._v("56.")]), _vm._v(" Encore")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm01",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Acknowledgements")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef6128c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 69
// module chunks = 0